<div class="forecast-wrapper">
  <app-user-section-access [sectionName]="guardSection()">
    <ng-template>
      @if ((companyFacade.isExistForecastInfo$ | async) === true) {
        @let forecast = (companyFacade.forecast$ | async) || null;

        <div class="app-company-info">
          <app-company-header-card
            [guardSectionName]="routerFacade.guardSectionName$ | async"
            [showHomePageLink]="(companyFacade.isShowCancelOption$ | async) === true"
            [forecast]="forecast"
          ></app-company-header-card>

          <div class="mat-tab-nav-bar-wrapper">
            <div class="mat-tab-nav-bar-block">
              <nav mat-tab-nav-bar mat-stretch-tabs="false" mat-align-tabs="start" [tabPanel]="tabPanel">
                @for (link of TAB_LINKS; track link) {
                  @if (
                    (!link.private || userFacade.user()) &&
                    ((link.name !== TAB_FULL_EDGAR_REPORT_LINK && link.name !== TAB_EDGAR_REPORT_LINK) ||
                      !!forecast?.summary)
                  ) {
                    <a
                      mat-tab-link
                      queryParamsHandling="merge"
                      [routerLink]="['./', link.name]"
                      routerLinkActive
                      #rla="routerLinkActive"
                      [active]="rla.isActive"
                    >
                      {{ link.label | translate }}
                    </a>
                  }
                }
              </nav>
              <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
            </div>
          </div>

          <router-outlet></router-outlet>
        </div>
      }
      @if ((companyFacade.isExistForecastInfo$ | async) === false && (inRequest$ | async) === false) {
        <app-forecast-not-found></app-forecast-not-found>
      }
    </ng-template>
  </app-user-section-access>
</div>
